import { logOut, updateLocalStorageToken } from "../../../../containers/resources/utils";
import HotelierService from "../../../../services/catalogs/HotelierService";

export const REQUEST_FETCH_HOTELIERS = "REQUEST_FETCH_HOTELIERS";
export const FETCH_HOTELIERS_SUCCESS = "FETCH_HOTELIERS_SUCCESS";
export const FETCH_HOTELIERS_ERROR = "FETCH_HOTELIERS_ERROR";

function requestFetchHoteliers() {
  return {
    type: REQUEST_FETCH_HOTELIERS,
  };
}

function fetchHoteliersSuccess(json) {
  return {
    type: FETCH_HOTELIERS_SUCCESS,
    hoteliers: json.data,
  };
}

function fetchHoteliersError(json) {
  return {
    type: FETCH_HOTELIERS_ERROR,
    error: json.data,
  };
}

export function fetchHoteliers(searchWord) {
  return (dispatch) => {
    dispatch(requestFetchHoteliers());
    return HotelierService.getHoteliers(searchWord).then((json) => {
      if (json.data.code === 200) {
        dispatch(fetchHoteliersSuccess(json.data));
      } else if (json.data.code === 202) {
        updateLocalStorageToken(json.data.token);
        dispatch(fetchHoteliers(searchWord));
      } else if (json.data.code === 498) {
        logOut();
      } else {
        dispatch(fetchHoteliersError(json.data));
      }
    });
  };
}
